import api from "./client";

export const previewCopyScada = async ({ siteId, startDate, endDate }) => {
  const payload = {
    site_id: siteId,
    start_date: startDate,
    end_date: endDate,
    apply: false,
  };
  const { data } = await api.post("/data-maintenance/copy", payload);
  return data;
};

export const executeCopyScada = async ({ siteId, startDate, endDate, onConflict }) => {
  const payload = {
    site_id: siteId,
    start_date: startDate,
    end_date: endDate,
    apply: true,
    on_conflict: onConflict,
  };
  const { data } = await api.post("/data-maintenance/copy", payload);
  return data;
};

export const startCopyJob = async ({ siteId, startDate, endDate, onConflict }) => {
  const payload = {
    site_id: siteId,
    start_date: startDate,
    end_date: endDate,
    on_conflict: onConflict,
  };
  const { data } = await api.post("/data-maintenance/copy/start", payload);
  return data;
};

export const fetchCopyJobStatus = async (jobId) => {
  const { data } = await api.get(`/data-maintenance/copy/status/${jobId}`);
  return data;
};

export const cancelCopyJob = async (jobId) => {
  const { data } = await api.post(`/data-maintenance/copy/cancel/${jobId}`);
  return data;
};

// Analytics jobs
export const checkAnalyticsExisting = async ({ siteId, startDate, endDate }) => {
  const { data } = await api.get(`/data-maintenance/analytics/check`, {
    params: { site_id: siteId, start_date: startDate, end_date: endDate },
  });
  return data;
};

export const startAnalyticsJob = async ({ siteId, mode, startDate, endDate, onConflict }) => {
  const payload = {
    site_id: siteId,
    mode,
    start_date: startDate,
    end_date: endDate,
    on_conflict: onConflict,
  };
  const { data } = await api.post(`/data-maintenance/analytics/start`, payload);
  return data;
};

export const fetchAnalyticsStatus = async (jobId) => {
  const { data } = await api.get(`/data-maintenance/analytics/status/${jobId}`);
  return data;
};

export const cancelAnalyticsJob = async (jobId) => {
  const { data } = await api.post(`/data-maintenance/analytics/cancel/${jobId}`);
  return data;
};

export const checkAvailabilityReportSnapshots = async ({ siteId, startDate, endDate }) => {
  const { data } = await api.get(`/data-maintenance/inverter-availability-reports/check`, {
    params: { site_id: siteId, start_date: startDate, end_date: endDate },
  });
  return data;
};

export const startAvailabilityReportJob = async ({ siteId, mode, startDate, endDate, onConflict }) => {
  const payload = {
    site_id: siteId,
    mode,
    start_date: startDate,
    end_date: endDate,
    on_conflict: onConflict,
  };
  const { data } = await api.post(`/data-maintenance/inverter-availability-reports/start`, payload);
  return data;
};

export const fetchAvailabilityReportStatus = async (jobId) => {
  const { data } = await api.get(`/data-maintenance/inverter-availability-reports/status/${jobId}`);
  return data;
};

export const cancelAvailabilityReportJob = async (jobId) => {
  const { data } = await api.post(`/data-maintenance/inverter-availability-reports/cancel/${jobId}`);
  return data;
};
